import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as summit from '../summit'

export const RESOURCE = {
  payload: {
    alias: 'allocation',
    appAlias: summit.RESOURCE.payload.alias,
    description: 'Understand where your team is focused',
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Allocation',
    page: { id: prebuilt.Page.Id.SummitAllocation },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
